module.exports = __webpack_public_path__ + "img/EXIMBANK.f9fbabdb.svg";